import React, {useState, createContext} from "react";
import zonesJSON from './zones.json';

export const ZonesContext = createContext({
    zones: zonesJSON,
    setZones: (zones) => {
    },
    selectedZones: {},
    toggleZone: (zone) => {
    }
});
export const ZonesProvider = ({children}) => {
    const toggleZone = (zoneId, zone) => {
        if (typeof state.selectedZones[zoneId] !== 'undefined') {
            delete state.selectedZones[zoneId];
        } else {
            state.selectedZones[zoneId] = zone;
        }

        manageZones();

        setState({...state, zones: state.zones, selectedZones: state.selectedZones});
    }

    Object.keys(zonesJSON).forEach((zoneID) => {
        if (typeof zonesJSON[zoneID].selectable === 'undefined') {
            zonesJSON[zoneID].selectable = true;
            zonesJSON[zoneID].locked = false;
        }
    })


    const initState = {
        zones: zonesJSON,
        selectedZones: {},
        toggleZone: toggleZone,
    }

    const [state, setState] = useState(initState)

    function manageZones() {
        const lockedZones = getLockedZones(state.selectedZones);
        const matches = getMatches(state.selectedZones);
        Object.keys(state.zones).forEach((zoneId) => {
            let zone = state.zones[zoneId];
            if (Object.keys(state.selectedZones).length >= 7) {
                zone.selected = true;
                zone.selectable = true;
                zone.locked = false;
            } else if (Object.keys(state.selectedZones).length < 7 && Object.keys(state.selectedZones).length > 0) {
                zone.locked = lockedZones.indexOf(parseInt(zoneId)) >= 0;
                zone.selected = Object.keys(state.selectedZones).indexOf(zoneId) >= 0;
                zone.selectable = matches.indexOf(parseInt(zoneId)) >= 0 || (Object.keys(state.selectedZones).indexOf(zoneId) >= 0);
            } else {
                zone.locked = false;
                zone.selected = false;
                zone.selectable = true;
            }

            state.zones[zoneId] = zone;
        });
    }

    function getLockedZones(selectedZones) {
        let lockedZones = [];
        Object.keys(selectedZones).forEach(function (zoneId) {
            let dependencies = [];
            Object.keys(selectedZones).forEach(function (subZoneId) {
                if (zoneId !== subZoneId) {
                    if (selectedZones[subZoneId].matches.includes(parseInt(zoneId))) {
                        dependencies.push(parseInt(subZoneId));
                    }
                }
            });
            if (dependencies.length === 2) {
                lockedZones.push(parseInt(zoneId));
            }
        });
        return lockedZones;
    }

    function getMatches(selectedZones) {
        let matches = [];
        Object.keys(state.selectedZones).forEach(function (key) {
            matches = matches.concat(selectedZones[key].matches);
        });

        return matches;
    }

    return (
        <ZonesContext.Provider value={state}>
            {children}
        </ZonesContext.Provider>
    );
}

export const LabelsContext = createContext({
    labels: {},
    getLabel: (id) => {

    }
});

export const LabelsProvider = (props) => {
    const getLabel = (id) => {
        if (typeof state.labels[id] !== 'undefined') {
            return state.labels[id];
        } else {
            return id;
        }
    }


    const initState = {
        labels: props.labels,
        getLabel: getLabel
    }

    const [state, setState] = useState(initState)

    return (
        <LabelsContext.Provider value={state}>
            {props.children}
        </LabelsContext.Provider>
    );
}
